import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

// 슬라이딩 애니메이션 (오른쪽에서 왼쪽으로 이동)
const slideIn = keyframes`
  from {
    transform: translateX(100%); /* 오른쪽에서 시작 */
  }
  to {
    transform: translateX(0); /* 화면에 완전히 나타남 */
  }
`;

const StyledElement = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: auto;

& .header-container {
    display: flex;
    position: absolute;
    z-index: 999;
    top: 0px;
    width: 100%;
    height: auto;
}

& .header {
    display: flex;  
    width: 100%;  
    position: relative;
    height: auto;
}

& .boss-button {
    object-fit: cover;
    position: absolute;
    width: 167px;
    top: 32px;
    left: 1195.5px;
    margin-left: auto;
    cursor: pointer;
  }
 
& .img-container {
    position: absolute;
    top: 0px;
    width: 100%;
}

& .img-body {
    width: 100%;
    height: auto;
}

& .img-btn-account {
    position: absolute;
    top: 485.33px;
    width: 195px;
    height: 55.67px;
    left: 664.5px;
    cursor: pointer;
}

.slide {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    animation-duration: 1s;
    animation-fill-mode: forwards;
        transition: z-index 0s; /* z-index 변경 시 전환 없이 바로 적용 */

}

.slide-in {
    animation-name: ${slideIn};
}
`;


export const BhHomepage1 = () => {
    const [visibleComponent, setVisibleComponent] = useState(1); // 1은 BhHomepage1_1, 2는 BhHomepage1_2
    const [isSliding, setIsSliding] = useState(false);

    // useEffect(() => {
    //     // 애니메이션과 컴포넌트 전환을 위한 타이머 설정
    //     const interval = setInterval(() => {
    //         setIsSliding(true); // 슬라이딩 시작
    //         setTimeout(() => {
    //             setVisibleComponent((prev) => (prev === 1 ? 2 : 1)); // 1과 2를 반복
    //             // setIsSliding(false); // 슬라이딩 종료
    //         }, 1000); // 슬라이딩 애니메이션 1초 후 컴포넌트 전환
    //     }, 6000); // 3초 간격으로 실행 (각 컴포넌트가 3초씩 보임)

    //     return () => clearInterval(interval); // 클린업 함수로 타이머 제거
    // }, []);

    const handleBossClick = () => {
        // window.location.href = 'https://beautyhama.shop/admin';  // 페이지 리디렉션
        alert('준비중인 페이지입니다. 조금만 기다려주세요.')
    };

    const handleFreeClick = () => {
        window.location.href = 'https://docs.google.com/forms/d/1QvynKcox74JqiJp-fITL3jpHXXwpXYkwgcO-6rIkegQ/viewform?edit_requested=true#responses';
    }

    return (
        <StyledElement>
            <img className="background-image" alt="background-image" src="/image/page1_1.png" />

            {/* <div className="img-container">
                <div
                    className={`slide ${visibleComponent === 1 ? (isSliding ? "slide-in" : "") : "hidden"}`}
                    style={{ zIndex: visibleComponent === 1 ? 2 : 1 }}
                >
                    <img className="img-body" alt="img-body" src="/image/page1_1.png" />
                </div>
                <div
                    className={`slide ${visibleComponent === 2 ? (isSliding ? "slide-in" : "") : "hidden"}`}
                    style={{ zIndex: visibleComponent === 2 ? 2 : 1 }}
                >
                    <img className="img-body" alt="img-body" src="/image/page1_2.png" />
                    <img className="img-btn-account" alt="img-btn-account" src="/image/button_account.png" onClick={handleFreeClick}/>
                </div>
            </div> */}

            <div className="header-container">
                <img className="header" alt="header" src="/image/1page_header.png" />
                <img className="boss-button" alt="boss-Button" src="/image/button1-1.png" onClick={handleBossClick} />
            </div>

        </StyledElement>
    );
};
